import {
  REPORT_RESET,
  REPORT_SET_STATE,
  REPORT_SET_SUBREPORT_CURRENT_PAGE,
  REPORT_SET_SUBREPORT_PAGES,
  REPORT_UPDATE_DATA,
  REPORT_UPDATE_SUBREPORT_CURRENT_PAGE,
  REPORT_UPDATE_SUBREPORT_PAGES
} from './types';

export const actions = {
  [REPORT_UPDATE_DATA]: ({commit}, payload) => {
    commit(REPORT_SET_STATE, payload);
  },

  [REPORT_RESET]: ({commit}) => {
    commit(REPORT_SET_STATE, {
      id: '',
      logo: '',
      reports: {},
      subReportCurrentPage: '',
      subReportPages: [],
      title: '',
      subtitle: ''
    });
  },

  [REPORT_UPDATE_SUBREPORT_PAGES]: ({commit}, payload) => {
    commit(REPORT_SET_SUBREPORT_PAGES, payload);
    commit(REPORT_SET_SUBREPORT_CURRENT_PAGE, (payload[0] || {}).value);
  },

  [REPORT_UPDATE_SUBREPORT_CURRENT_PAGE]: ({commit}, payload) => {
    commit(REPORT_SET_SUBREPORT_CURRENT_PAGE, payload);
  }
};
